<script setup lang="ts">
import IconStar from "~/assets/icons/iconStar.vue";
const { averageRating, reviewCount, fetchTestimony } = useTestimony();

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  })

  // handle rate
  onMounted(() => {
    fetchTestimony(props.item.testimonies);
  })
</script>

<template>
  <NuxtLink :to="'/tour/' + props?.item.slug" class="space-y-4">
    <div class="relative w-full overflow-hidden h-28 rounded-xl">
      <img
        v-if="props?.item.photos.length > 0"
        :src="props?.item.photos[0].path"
        alt=""
        class="object-cover object-center"
      />
    </div>
    <div class="space-y-2 text-left">
      <div class="flex items-center">
        <div class="flex gap-1">
            <img v-for="i in 5" :key="i" :src="i <= averageRating ? '/icons/star.svg' : '/images/star_outline.png'"
              alt="star" width="15" />
        </div>
        <span class="ml-2 text-xs text-gray-500">({{ reviewCount }} Reviews)</span>
      </div>
      <h4 class="">{{ props?.item.title }}</h4>
      <div>
        <span class="mr-0.5 font-semibold text-secondary-80 md:font-medium"
          >From US$ {{ props?.item.prices[props?.item.prices.length - 1]?.price ?? 0 }}</span
        >

        <sup class="text-gray-500">per person</sup>
      </div>
    </div>
  </NuxtLink>
</template>
